// 腾讯云视频上传
import Axios from '../ajax'
import { MessageBox } from 'element-ui'
import {loginUrl} from '../const'
export default {
  methods: {
    async login () {
      // let {data} = await Axios.get(loginUrl)
      location.href= "https://kui.kingdee.com/yzjlogin/?redirect_uri=" +
        encodeURIComponent(window.location.origin+window.location.pathname);
      // if (data.errcode === 1018) { // 记录当前页面
      //   sessionStorage.setItem('currentUrl', location.href)
      //   location.href = data.data.url
      // }
      // if (data.errcode === 6002) {
      //   location.reload()
      // }
    },
    isLogin (tips = '请登录') {
      MessageBox.confirm(tips, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        center: true
      }).then(() => {
        this.login()
      }).catch(() => {
      });
    },
    getName (val) {
      return val.name || val.username || val.nickname
    },
    getPhoto (val) {
      return val.photoUrl || val.avatar
    }
  }
}